import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-slider',
  standalone: true,
  imports: [CommonModule, MatSliderModule, FormsModule, TranslateModule],
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.scss'],
})
export class CustomSliderComponent {
  @Output() valueChange = new EventEmitter<number>();

  readonly values = ['5', '10', '15', '30', '50'];

  private _valueIndex: number;

  @Input()
  set value(newValue: number) {
    const newIndex = this.values.indexOf(newValue.toString());
    // Nur aktualisieren, wenn der Wert gültig ist und sich vom aktuellen unterscheidet
    if (newIndex !== -1 && this.values[newIndex] !== this.selectedValue) {
      this.valueIndex = newIndex;
    }
  }

  // Getter für das @Input
  get value(): string {
    return this.selectedValue;
  }

  get valueIndex(): number {
    return this._valueIndex;
  }

  set valueIndex(newIndex: number) {
    this._valueIndex = newIndex;
    this.valueChange.emit(Number(this.selectedValue));
  }

  get selectedValue(): string {
    return this.values[this.valueIndex];
  }
}
